import { Modal } from "@mui/material";
import styled from "styled-components";
import ButtonComponent from "../button";
import IconSAT from "../../assets/images/icon-sat-1.svg"
import IconFail from "../../assets/images/icon-fail.svg"
import * as htmlToImage from "html-to-image";
import IconLocation from '../../assets/images/icon-location-1.svg'
import ImageGirl from '../../assets/images/image-girl.png'
import ImageScanMe from '../../assets/images/image-scan-me.png'
import QRCode from "react-qr-code";

const Container = styled.div`
    padding: 36px;
    border-radius: 16px;
    background-color: #FFFFFF;
    border: 1px solid #F1F1F190;
    box-shadow: 0px 5px 30px 0px #00266F29;
    display: flex;
    flex-direction: column;

    &:focus-visible {
        outline: none;
    }

    .image {
        margin-bottom: 24px;
    }

    .label {
        color: #25368D;
        font-size: 24px;
        font-weight: 500;
        line-height: 35.88px;
        text-align: center;
        margin-bottom: 8px;
    }

    .sub-label {
        color: #505050;
        font-size: 15px;
        font-weight: 400;
        line-height: 22.43px;
        text-align: center;
        white-space: pre-line;
        margin-bottom: 24px;
    }

    .button-container {
        margin-top: 16px;
        margin-bottom: 0px;

        .button-box {
            width: 100%;
        }
    }
`;

const PageLayout = styled.div`
    width: 496px;
    height: 702px;
    background-color: #EBF9F9;

    .container {
        width: calc(100% - 32px);
        height: calc(100% - 32px);
        margin: 16px;
    }

    .label {
        color: #25368D;
        font-size: 24px;
        font-weight: 500;
        line-height: 35.88px;
        text-align: center;
        margin: 16px 24px 24px 24px;
    }

    .qr-code-box {
        margin-bottom:24px;
    }

    .label-description {
        color: #2A2A2A;
        font-size: 20px;
        font-weight: 500;
        text-align: center;
        margin: 0px 24px 24px 24px;
    }

`;

const PageLayout2 = styled.div`
    width: 496px;
    height: 702px;
    background: linear-gradient(to right, #7e45df, #4f6db8, #30a3a5, #20c070);

    .container {
        width: calc(100% - 32px);
        height: calc(100% - 16px);
        margin: 0px 16px 16px 16px;
        display: flex;
        flex-direction: column;
    }

    .label {
        color: #FFFFFF;
        font-size: 24px;
        font-weight: 500;
        line-height: 35.88px;
        text-align: center;
        margin: 0px 24px 8px 24px;
    }

    .line {
        width: calc(100% - 96px);
        height: 2px;
        margin: 0px 48px 24px 48px;
        background-color: #FFE127;
    }

    .qr-code-panel {
        display: flex;
        margin-bottom:24px;

        .qr-code-box {
            width: 240px;
            height: 360px;
            border-radius: 40px;
            background-color: #FFE127;
            position: relative;
        }
    }

    .label-description {
        color: #2A2A2A;
        font-size: 20px;
        font-weight: 500;
        text-align: center;
        margin: 0px 24px 24px 24px;
    }

    .footer-box {
        margin-top: auto;
        margin-bottom: 0px;

        .label-1 {
            color: #FFFFFF;
            font-size: 16px;
            font-weight: 600;
            text-align: left;
        }

        .label-2 {
            color: #FFFFFF;
            font-size: 12px;
            font-weight: 400;
            text-align: left;
        }

        .label-3 {
            color: #FFFFFF;
            font-size: 10px;
            font-weight: 300;
            text-align: left;
        }
    }

`;

const Card = styled.div`
    min-height: 50px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    border-radius: 13px;
    border: 1px solid #F1F1F190;
    box-shadow: 0px 5px 14px 0px #00266F11;
    background-color: #FFFFFF;
    padding: 16px;
    margin: 0px 24px 0px 24px;

    .label-title {
        color: #25368D;
        font-size: 15px;
        font-weight: 400;
        line-height: 22.43px;
        text-align: left;
    }

    .label-sub-title {
        color: #505050;
        font-size: 14px;
        font-weight: 300;
        line-height: 20.93px;
        text-align: left;
        padding-top: 2px;
    }
`;

function EFQRcodePrinterModal({
    open,
    dataItem,
    buttonLabel,
    styleContainer,
    onConfirm,
}) {
    function handleConfirm() {
        onConfirm && onConfirm();
    }
    function handleDownload() {
        const element = document.getElementById("qrcode_print");
        if (!element) return
        htmlToImage
            .toSvg(element)
            .then(function (dataUrl) {
                const link = document.createElement("a");
                link.href = dataUrl;
                link.download = `qrcode_print.svg`;
                link.click();
            })
            .catch(function (error) {
                console.error("Error generating QR code:", error);
            });
    }

    return (
        <Modal
            className="content-center"
            open={open || false}
        >
            <Container
                style={{ ...styleContainer }}
            >
                <PageLayout id="qrcode_printx" style={{ display: "none" }}>
                    <div className="container">
                        <div style={{ display: "flex", justifyContent: "end" }}>
                            <img alt="img" style={{ height: "100px" }} src={IconSAT} />
                        </div>
                        {/* <div className="label">{dataItem?.title || ""}</div> */}
                        <div className="label">ระบบเก็บข้อมูลจำนวนผู้ใช้บริการ<br />และแบบสอบถามประเมินความพึงพอใจ<br />ของการกีฬาแห่งประเทศไทย</div>
                        {dataItem?.type === "Place" &&
                            <Card>
                                <div className="label-title">{dataItem?.location || ""}</div>
                                <div className="vertical-center" style={{ marginTop: "4px" }}>
                                    <img alt="img" src={IconLocation} style={{ marginRight: "8px" }} />
                                    <div className="label-sub-title"> {dataItem?.province || ""}</div>
                                </div>
                            </Card>
                        }
                        <div className="qr-code-box content-center">
                            <QRCode
                                size={160}
                                id="qrcode-anonymous"
                                bgColor="transparent"
                                value={dataItem?.url_qrcode}
                            />
                        </div>
                        <div className="label-description">{dataItem?.qrcode_description || ""}</div>
                    </div>
                </PageLayout>

                <PageLayout2 id="qrcode_print">
                    <div className="container">
                        <div style={{ height: "24px" }}></div>
                        <div className="label">ระบบเก็บข้อมูลจำนวนผู้ใช้บริการ<br />และแบบสอบถามประเมินความพึงพอใจ<br />ของการกีฬาแห่งประเทศไทย</div>
                        <div className="line"></div>
                        <div className="qr-code-panel content-center">
                            <div className="qr-code-box content-center">
                                <img alt="img" src={ImageScanMe} style={{ height: "300px" }} />
                                <div style={{ position: "absolute", marginTop: "90px", marginLeft: "1px" }}>
                                    <QRCode
                                        size={100}
                                        id="qrcode-anonymous"
                                        bgColor="transparent"
                                        value={dataItem?.url_qrcode}
                                    />
                                </div>
                                {dataItem?.anonymous && <div style={{ position: "absolute", bottom: "20px", color: "#25368D" }}>ไม่ระบุตัวตัว</div>}
                            </div>
                            <img alt="img" src={ImageGirl} style={{ height: "360px", marginLeft: "-16px", zIndex: "1" }} />
                        </div>
                        <Card>
                            <div className="label-title">{dataItem?.type === "Place" ? dataItem?.location || "" : dataItem?.title || ""}</div>
                            {dataItem?.type === "Place" &&
                                <div className="vertical-center" style={{ marginTop: "4px" }}>
                                    <img alt="img" src={IconLocation} style={{ marginRight: "8px" }} />
                                    <div className="label-sub-title"> {dataItem?.province || ""}</div>
                                </div>
                            }
                        </Card>
                        <div className="content-center footer-box">
                            <div className="vertical-center" style={{ gap: "8px" }}>
                                <img alt="img" style={{ height: "36px" }} src={IconSAT} />
                                <div>
                                    <div className="label-1">การกีฬาแห่งประเทศไทย</div>
                                    <div className="label-2">Sports Authority Of Thailand</div>
                                </div>
                                <div className="label-3">
                                    <div style={{ marginBottom: "4px" }}>286 ถ.รามคำแหง หัวหมาก บางกะปิ 10240</div>
                                    <div>โทร 02-186-7111 ต่อ 7912 www.sat.or.th</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </PageLayout2>

                <div className="button-container horizontal-center" style={{ gap: "16px" }}>
                    <div className="button-box">
                        <ButtonComponent
                            label={"ดาวน์โหลด"}
                            variant={"primary"}
                            sceenSize={"lg"}
                            style={{ maxWidth: "100%" }}
                            onClick={handleDownload}
                        />
                    </div>
                    <div className="button-box">
                        <ButtonComponent
                            label={buttonLabel || "กลับหน้าหลัก"}
                            variant={"secondary"}
                            sceenSize={"lg"}
                            style={{ maxWidth: "100%" }}
                            onClick={handleConfirm}
                        />
                    </div>
                </div>
            </Container>
        </Modal>
    )
}

export default EFQRcodePrinterModal;